import { useContext } from 'react'
import { RdtContext } from '../rdt-context'
import { useRadix } from '../radixProvider';

export const useRdt = () => {
  const {rdt} = useRadix();

  return rdt
}
